import { __awaiter } from "tslib";
import * as React from 'react';
import { StyledAutocompleteWrapper, StyledErrorResultsList, StyledResultsList, } from './Autocomplete.styled';
import { TextInput } from '../forms';
import { OptionList } from './OptionList';
import { useField } from 'formik';
import { geocodeByAddress } from 'react-places-autocomplete';
import { transformResult } from './helpers';
export const DEFAULT_ERROR_RESULT = {
    label: 'An error occurred, please try again.',
};
export const Autocomplete = (props) => {
    const { results, error, errorMessage, inputPlaceholder, onChange, onFocus, onSelect, label = '', description, name, } = props;
    const [inputValue, setInputValue] = React.useState('');
    const showResultsList = !error && !!(results && results.length);
    const [closed, setClosed] = React.useState(true);
    // Formik connector
    // first item of the return array (field) of useField hook is unused so not defined
    const [, meta, helpers] = useField(name);
    const { error: formikError } = meta;
    const { setValue, setError, setTouched } = helpers;
    /*
    This assumes validation will only check to ensure a non-empty text field. Entries with no search results,
    eg long strings or non-alphanumeric characters, will return an error message in the options list indicating
    no results for the search term.
    */
    React.useEffect(() => {
        if (inputValue) {
            void setValue(inputValue);
            setError(undefined);
        }
    }, [inputValue, formikError]);
    return (React.createElement(StyledAutocompleteWrapper, null,
        React.createElement(TextInput, Object.assign({ name: name, label: label, description: description, value: inputValue, "data-testid": "autocomplete" }, (onFocus ? { onFocus } : {}), { onChange: (e) => {
                setInputValue(e.target.value);
                setClosed(false);
                if (onChange)
                    onChange(e.target.value);
                if (!e.target.value) {
                    void setValue('');
                    void setTouched(true);
                }
            }, placeholder: inputPlaceholder || '', style: { marginBottom: showResultsList ? '0.25rem' : '1rem' } })),
        showResultsList && !closed && (React.createElement(StyledResultsList, null,
            React.createElement(OptionList, { onSelect: (item) => __awaiter(void 0, void 0, void 0, function* () {
                    void setValue(item.label);
                    void setTouched(false);
                    setInputValue(item.label);
                    if (onSelect) {
                        onSelect(item);
                        const result = yield geocodeByAddress(item.label);
                        void setValue({
                            raw: item.label,
                            result: transformResult(result[0]),
                        });
                        setClosed(true);
                    }
                }), options: results }))),
        error && !closed && (React.createElement(StyledErrorResultsList, null,
            React.createElement(OptionList, { onSelect: () => __awaiter(void 0, void 0, void 0, function* () {
                    setClosed(true);
                    yield Promise.resolve();
                }), options: errorMessage
                    ? [{ label: errorMessage }]
                    : [DEFAULT_ERROR_RESULT] })))));
};
//# sourceMappingURL=Autocomplete.js.map